import * as React from 'react';
import PropTypes from 'prop-types';
import tokens from '../../Tokens/tokens';
const { colors, spacing } = tokens;

const IconFilter = ({ title, titleId, ...props }) => {
    const sizeArray = Object.entries(spacing.icons);
    const colorArray = Object.entries(colors.icons);
    const sizeOptions = new Map(sizeArray);
    const displaySize = sizeOptions.get(props.size);
    const colorOptions = new Map(colorArray);
    const displayColor = colorOptions.get(props.color);
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 16 16'
            fill={props.color && displayColor}
            aria-hidden={!title}
            role={title ? 'img' : null}
            width={props.size && displaySize}
            height={props.size && displaySize}
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path d='M15 12H7.82a3 3 0 00-5.64 0H1a1 1 0 000 2h1.18a3 3 0 005.64 0H15a1 1 0 000-2zM5 14a1 1 0 111-1 1 1 0 01-1 1zM1 4h1.18a3 3 0 005.64 0H15a1 1 0 000-2H7.82a3 3 0 00-5.64 0H1a1 1 0 000 2zm4-2a1 1 0 11-1 1 1 1 0 011-1z' />
            <path d='M15 7h-1.18a3 3 0 00-5.64 0H1a1 1 0 000 2h7.18a3 3 0 005.64 0H15a1 1 0 000-2zm-4 2a1 1 0 111-1 1 1 0 01-1 1z' />
        </svg>
    );
};

IconFilter.propTypes = {
    title: PropTypes.string,
    titleId: PropTypes.string,
    size: PropTypes.oneOf(['sm', 'md']),
    color: PropTypes.oneOf(['primaryBlue', 'secondaryBlue', 'darkGrey', 'white']),
};
IconFilter.defaultProps = {
    size: 'sm',
    color: 'darkGrey',
    focusable: false,
};
export default IconFilter;
